import React from 'react';
import warm from './warm.svg';
import cool from './cool.svg';
import neutral from './neutral.svg';

import styles from './UnderskinQuestion.module.css';

export type UnderskinQuestionType =
  | 'UNDERSKIN_COLOR_WARM'
  | 'UNDERSKIN_COLOR_COOL'
  | 'UNDERSKIN_COLOR_NEUTRAL';

interface UnderskinQuestionProps {
  type: UnderskinQuestionType;
  description: string;
}

const UnderskinQuestion: React.FunctionComponent<UnderskinQuestionProps> = ({
  type,
  description,
}) => {
  if (!type) return null;

  const getUnderskinColor = () => {
    switch (type) {
      case 'UNDERSKIN_COLOR_WARM':
        return 'Warm';
      case 'UNDERSKIN_COLOR_COOL':
        return 'Cool';
      case 'UNDERSKIN_COLOR_NEUTRAL':
        return 'Neutral';
      default:
        return '';
    }
  };

  const getImageUrl = () => {
    switch (type) {
      case 'UNDERSKIN_COLOR_WARM':
        return warm;
      case 'UNDERSKIN_COLOR_COOL':
        return cool;
      case 'UNDERSKIN_COLOR_NEUTRAL':
        return neutral;
      default:
        return '';
    }
  };

  return (
    <div className={styles.underskinColorQuestionContainer}>
      <div className={styles.imageContainer}>
        <img src={getImageUrl()} alt={getUnderskinColor()} />
        {getUnderskinColor()}
      </div>
      <div className={styles.descriptionContainer}>{description}</div>
    </div>
  );
};

export default UnderskinQuestion;
